import { Dispatch, FunctionComponent, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "@/components";

import { BlacklistCsvUploadFields } from "./BlacklistCsvUploadFields";
import { useUploadBlacklistCsv } from "./useUploadBlacklistCsv";

interface UploadBlacklistModalProps {
	isOpen: boolean;
	setIsOpen: Dispatch<SetStateAction<boolean>>;
	isGlobal: boolean;
}

export const UploadBlacklistModal: FunctionComponent<UploadBlacklistModalProps> = ({
	isOpen,
	setIsOpen,
	isGlobal,
}) => {
	const { t } = useTranslation();
	const upload = useUploadBlacklistCsv({ isGlobal, onImported: () => setIsOpen(false) });

	return (
		<Modal
			handleClose={() => setIsOpen(false)}
			handleSave={upload.submit}
			isLoading={upload.isLoading}
			isOpened={isOpen}
			submitButtonText={t("basics.confirm")}
			title={t("blacklist.create.title")}
		>
			<BlacklistCsvUploadFields upload={upload} />
		</Modal>
	);
};
